import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

import Loading from '../components/Loading';
import Player from '../components/Player';
import Embed from '../components/Embed';

export default (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState('loading ...');
  const [src, setSrc] = useState({url: '', title: ''});

  const id = props.match.params.id;

  const onLoad = useCallback(async () => {
    try {
      const url = `${process.env.REACT_APP_CONFIG_URL}/${id}/media.json`;
      console.log('Fetching: ', url);
      const response = await axios.get(url);
      if (response.status === 200) {
        const data = response.data;
        if (data && data.hls) {
          const src = {url: data.hls, title: ''}
          setSrc(src);
          setIsLoading(false);
        }
      }
      setMessage("Sorry, video not found.");
    }
    catch(e) {
      console.log('onLoad', e);
      setMessage(e);
    }
  }, [id])

  useEffect(() => {
    onLoad()
  }, [onLoad])

  return (
    <>
      { isLoading &&
        <Loading message={message} />
      }
      { !isLoading && (props.type === "player") &&
        <Player src={src} />
      }
      { !isLoading && (props.type === "embed") &&
        <Embed src={src} />
      }
    </>
  );
};
